import {
  // AsnVolumeColumnDefinition,
  CreatedAtColumnDefinition,
  FlaggedColumnDefinition,
  AsnNumberColumnDefinition,
  WeightColumnDef,
  PoNumberColumnDef,
  TotalCarton,
} from "components/AGTable/NewColumns/ColumnDefinition";
import { AsnDetails } from "components/AGTable/NewColumns/AsnDetails";
import config from "config/config";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  filter: true,
};

const columnDefs = [
  AsnDetails,
  AsnNumberColumnDefinition,
  PoNumberColumnDef("po"),
  CreatedAtColumnDefinition,
  // AsnVolumeColumnDefinition("volume"),
  WeightColumnDef,
  TotalCarton,
];

if (config.getFlaggedFeatureFromLocalStorage())
  columnDefs.splice(4, 0, FlaggedColumnDefinition);

export const asnGrid = {
  columnDefs: columnDefs,
  defaultColDef,
};
